import { call, put } from "redux-saga/effects";
import { authApi } from "@services/api";
import { externalLoginActions, externalLoginSuccessAction } from "../slices";
import { showFailureToast } from "@helpers";

function* externalLoginWorker({ payload }) {
  try {
    yield put(externalLoginActions.pending());
    const response = yield call(authApi.externalLogin, payload);
    yield put(externalLoginActions.success());
    yield put(externalLoginSuccessAction(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(externalLoginActions.failure(error));
    showFailureToast(
      "Sorry, we were failed in connecting to 3rd party'service"
    );
  }
}

export { externalLoginWorker };
